import { render, staticRenderFns } from "./ItemsApiGrid.vue?vue&type=template&id=2fecfa4b&"
import script from "./ItemsApiGrid.vue?vue&type=script&lang=js&"
export * from "./ItemsApiGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports